import { CheckRollnoData } from "./../class/chkrollnodata";
import { Router } from "@angular/router";
import { Editdatapojo } from "./../class/editdatapojo";
import { SavedialogComponent } from "./../savedialog/savedialog.component";
import { UpdatedialogComponent } from "./../updatedialog/updatedialog.component";
import { Common } from "./Common";
import { AppconfigService } from "./../service/appconfig.service";
import { StudentSave } from "./../studentregistration/StudentSave";
import { StudentevaluationService } from "./../service/studentevaluation.service";
import { TypeListitem } from "./../class/typelistitem";
import { Listitem } from "./../class/listitem";
import { StudentDetail } from "./../class/StudentDetail";
import { LoadDetailPojo } from "./../class/LoadDetailPojo";
import {
  UntypedFormControl,
  Validators,
  FormGroupDirective,
  NgForm,
} from "@angular/forms";
import { ReturnStatus } from "./../class/return-status";
import { DD_MMM_YYYY, moment } from "./../class/datecustomformat";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DatePipe } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  ErrorStateMatcher,
} from "@angular/material/core";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import {} from "@angular/material/core";
import {
  Component,
  OnInit,
  AfterContentInit,
  ViewChild,
  TemplateRef,
  OnDestroy,
  HostListener,
} from "@angular/core";
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from "ngx-loading";
import { NgxSpinnerService } from "ngx-spinner";
import { JilabaAesED } from "../common/JilabaAesED";
import { JilabaKeyEnum } from "../common/JilabaKeyEnum";
interface graduation {
  value: string;
  name: string;
}

const PrimaryRed = "#dd0031";
const SecondaryBlue = "#006ddd";

export interface SaveDialogData {
  dialogstudentno: string;
}

export interface UpdateDialogData {
  dialogstudentno: string;
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: UntypedFormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-studentregistration",
  templateUrl: "./studentregistration.component.html",
  styleUrls: ["./studentregistration.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: DD_MMM_YYYY },
  ],
})
export class StudentregistrationComponent
  implements OnInit, AfterContentInit, OnDestroy
{
  @ViewChild("ngxLoading") ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild("customLoadingTemplate") customLoadingTemplate: TemplateRef<any>;
  clgtype: string;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public loading = false;
  public primaryColour = PrimaryRed;
  public secondaryColour = SecondaryBlue;
  public coloursEnabled = false;
  public loadingTemplate: TemplateRef<any>;
  public blnsave = true;
  public config = {
    animationType: ngxLoadingAnimationTypes.none,
    primaryColour: this.primaryColour,
    secondaryColour: this.secondaryColour,
    tertiaryColour: this.primaryColour,
    backdropBorderRadius: "3px",
  };
  public date: any;
  dob: any = moment();
  collegename: string;
  collegetype: string;
  studentcount: string;

  listgraduation: graduation[] = [
    { value: "E", name: "Engineering" },
    { value: "P", name: "Polytechnic" },
    { value: "A", name: "Arts and Science" },
  ];

  setdate: Date = new Date(1999, 0, 1);
  setMindate: Date = new Date(1976, 0, 1);
  yearpassdate: any = moment();
  currentDate: any = moment();
  maxDate: any = moment();
  minDate: any = moment();
  emailFormControl = new UntypedFormControl("", [
    Validators.required,
    Validators.email,
  ]);
  matcher = new MyErrorStateMatcher();
  blnindia: boolean;
  show: boolean;
  blnabroad: boolean;
  blntravel: boolean;

  test: string;
  public datefromcontrol: Date;
  studentno: string;
  returnstatus: ReturnStatus = new ReturnStatus();
  chkrollnodata: CheckRollnoData = new CheckRollnoData();
  email = new UntypedFormControl("", [Validators.required, Validators.email]);
  selecetdFile: File;
  loadDetailPojo: LoadDetailPojo = new LoadDetailPojo();
  studentdetail: StudentDetail = new StudentDetail();
  studentsave: StudentSave;
  loaddetailspojo: LoadDetailPojo = new LoadDetailPojo();
  lstcollege: Array<Listitem> = new Array<Listitem>();
  lstdepartment: Array<TypeListitem> = new Array<TypeListitem>();
  lsteducation: Array<TypeListitem> = new Array<TypeListitem>();
  lsttechnical: Array<TypeListitem> = new Array<TypeListitem>();
  lstdatabase: Array<TypeListitem> = new Array<TypeListitem>();
  lstpackage: Array<TypeListitem> = new Array<TypeListitem>();
  lstlanguage: Array<TypeListitem> = new Array<TypeListitem>();

  selecteddepartment: TypeListitem = new TypeListitem();
  selectededucation: TypeListitem = new TypeListitem();
  selectedtechnical: Array<TypeListitem> = new Array<TypeListitem>();
  selecteddatabase: Array<TypeListitem> = new Array<TypeListitem>();
  selectedpackage: Array<TypeListitem> = new Array<TypeListitem>();
  selectedlanguage: Array<TypeListitem> = new Array<TypeListitem>();
  selecteddetails: Array<TypeListitem> = new Array<TypeListitem>();
  lsteditdata: Array<Editdatapojo> = new Array<Editdatapojo>();
  blnedit = false;
  lstfamiliar: Array<TypeListitem> = new Array<TypeListitem>();
  blnchkmobno = false;
  blnchkrollno = false;
  oldrollno: string;
  oldmobileno: string;
  btnsavecolor = "primary";
  clgName: boolean = true;
  clgAddress: boolean = true;
  async ngOnInit() {
    await this.loaddetails();
    if (AppconfigService.otpstatus === true) {
      this.blnedit = true;

      this.loaddata();
    } else {
      this.studentdetail.clgcode = AppconfigService.clgcode;
      this.collegename = AppconfigService.clgname;
      this.studentcount = AppconfigService.studentcount;
    }

    if (AppconfigService.clgcode == "JS") {
      this.clgName = false;
      this.clgAddress = false;
    }
    setTimeout(() => {
      let ele: HTMLInputElement;
      ele = <HTMLInputElement>document.getElementById("cmbyop");
      ele.value =
        new Date().getFullYear() +
        (new Date().getMonth() <= 3 ? -1 : 0) +
        "-03";
      this.studentdetail.yearofpas =
        new Date().getFullYear() +
        (new Date().getMonth() <= 3 ? -1 : 0) +
        "-03";
    }, 50);
  }

  ngAfterContentInit() {
    document.getElementById("cmbyop").focus();
  }

  ngOnDestroy() {
    window.location.reload();
  }

  constructor(
    private studentevaluation: StudentevaluationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService
  ) {
    this.dob = moment()
      .date(this.setdate.getDate())
      .year(this.setdate.getFullYear())
      .month(this.setdate.getMonth());
    this.studentdetail.dob = new Date(
      this.dob.year(),
      this.dob.month(),
      this.dob.date()
    );
    this.minDate = moment()
      .date(this.setMindate.getDate())
      .year(this.setMindate.getFullYear())
      .month(this.setMindate.getMonth());
    this.show = false;
    this.blnindia = false;
    this.blnabroad = false;
    this.blntravel = false;
    this.modelChange();

    this.studentdetail.image = "assets/img/user.png";
    this.studentsave = new StudentSave(studentevaluation);
    this.studentdetail.age = this.currentDate.year() - this.dob.year();
  }

  @HostListener("window:beforeunload", ["$event"])
  @HostListener("window:reload", ["$event"])
  @HostListener("window:popstate", ["$event"])
  async releaseLock(event) {
    if (AppconfigService.otpstatus === true) {
      let map: any = {
        regNo: AppconfigService.regno,
        tocken: JilabaAesED.Encrypt(
          AppconfigService.regno,
          JilabaKeyEnum.CommonKey
        ),
      };

      await this.studentevaluation.releaseLock(map).then((data) => {
        if (this.returnstatus.status === false) {
          console.log(this.returnstatus.description);
        }
      });
    }
  }
  colorchange() {
    this.btnsavecolor = "warn";
  }

  colorchangeback() {
    this.btnsavecolor = "primary";
  }
  back() {
    this.router.navigate(["/main"]);
  }
  DateChangeEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.studentdetail.dob = new Date(
      this.dob.year(),
      this.dob.month(),
      this.dob.date()
    );
    this.studentdetail.age = this.currentDate.year() - this.dob.year();
  }

  async loaddetails() {
    await this.studentevaluation.loaddetails().then((data) => {
      try {
        this.returnstatus = data;
        if (this.returnstatus.status === true) {
          this.loadDetailPojo = this.returnstatus.returnObject;

          this.lstdepartment = this.loadDetailPojo.lstdepartment;
          this.lsteducation = this.loadDetailPojo.lsteducation;
          this.lsttechnical = this.loadDetailPojo.lsttechnical;
          this.lstdatabase = this.loadDetailPojo.lstdatabase;
          this.lstpackage = this.loadDetailPojo.lstpackage;
          this.lstlanguage = this.loadDetailPojo.lstlanguage;
        }
      } catch (error) {
        console.log(error.message);
        alert(error.message);
      }
    });
  }

  loaddata() {
    let map: any = {
      mobileno: AppconfigService.mobileno,
      tocken: JilabaAesED.Encrypt(
        AppconfigService.mobileno,
        JilabaKeyEnum.CommonKey
      ),
    };
    this.studentevaluation.loadEditData(map).subscribe((data) => {
      try {
        this.returnstatus = data;
        if (this.returnstatus.status === true) {
          this.lsteditdata = this.returnstatus.returnObject;

          this.studentdetail = this.lsteditdata[0].lststudent[0];
          this.lstfamiliar = this.lsteditdata[0].lstfamiliar;
          this.studentdetail.image =
            this.lsteditdata[0].imageurl + AppconfigService.regno + ".jpg";
          if (this.studentdetail.clgcode == "JS") {
            this.clgName = false;
            this.clgAddress = false;
          }
          this.studentdetail.cnfrmmobno = this.studentdetail.mobno;
          this.studentcount = this.studentdetail.studentcount;
          this.oldmobileno = this.studentdetail.mobno;
          this.oldrollno = this.studentdetail.clgrollno;
          this.collegename = this.studentdetail.clgname;
          this.collegetype = this.studentdetail.clgtype;
          this.dob = moment(this.studentdetail.dob);
          this.studentdetail.studno = AppconfigService.regno;
          this.modelEditChange();
          this.selectedtechnical = new Array<TypeListitem>();
          this.selecteddatabase = new Array<TypeListitem>();
          this.selectedpackage = new Array<TypeListitem>();
          this.selectedlanguage = new Array<TypeListitem>();
          this.lstfamiliar.forEach((each) => {
            if (each.type === "E") {
              this.lsteducation.forEach((eacheducation) => {
                if (eacheducation.value === each.value) {
                  this.selectededucation = eacheducation;
                  return true;
                }
              });
            } else if (each.type === "D") {
              this.lstdepartment.forEach((eachdept) => {
                if (eachdept.value === each.value) {
                  this.selecteddepartment = eachdept;
                  return true;
                }
              });
            } else if (each.type === "T") {
              this.lsttechnical.forEach((eachtech) => {
                if (eachtech.value === each.value) {
                  this.selectedtechnical.push(eachtech);
                }
              });
            } else if (each.type === "B") {
              this.lstdatabase.forEach((eachdb) => {
                if (eachdb.value === each.value) {
                  this.selecteddatabase.push(eachdb);
                }
              });
            } else if (each.type === "P") {
              this.lstpackage.forEach((eachpackage) => {
                if (eachpackage.value === each.value) {
                  this.selectedpackage.push(eachpackage);
                }
              });
            } else if (each.type === "L") {
              this.lstlanguage.forEach((eachlanguage) => {
                if (eachlanguage.value === each.value) {
                  this.selectedlanguage.push(eachlanguage);
                }
              });
            }
          });
        } else {
          console.log(this.returnstatus.description);
        }
      } catch (error) {
        console.log(this.returnstatus.description);
      }
    });
  }

  // loadclg() {
  //   let map:any={
  //     "clgtype":this.studentdetail.clgtype,
  //     "tocken":JilabaAesED.Encrypt(this.studentdetail.clgtype,JilabaKeyEnum.CommonKey)
  //   };
  //   this.studentevaluation.loadclg(map).subscribe(data => {
  //     try {
  //       this.returnstatus = data;
  //       if (this.returnstatus.status === true) {
  //         if (!(this.returnstatus.returnObject instanceof Array)) {
  //           throw new Error("Given Data is not valid");
  //         }
  //         let hashData = "";
  //         this.returnstatus.returnObject.forEach(element => {
  //           if (!(element instanceof Listitem)) {
  //             throw new Error("Invalid Datatype !...");
  //           }
  //           hashData += new String(element.value);
  //         });

  //         if (hashData !== this.returnstatus.description) {
  //           throw new Error("Data Tampered");
  //         }
  //         this.lstcollege = this.returnstatus.returnObject;

  //       }
  //     } catch (error) {
  //       console.log(this.returnstatus.description);
  //     }
  //   });
  // }

  modelEditChange() {
    if (this.studentdetail.indiaplc === "Y") {
      this.blnindia = true;
    } else {
      this.blnindia = false;
    }

    if (this.studentdetail.abroad === "Y") {
      this.blnabroad = true;
    } else {
      this.blnabroad = false;
    }

    if (this.studentdetail.travel === "Y") {
      this.blntravel = true;
    } else {
      this.blntravel = false;
    }
  }

  modelChange() {
    if (this.blnindia === true) {
      this.studentdetail.indiaplc = "Y";
    } else {
      this.studentdetail.indiaplc = "N";
    }

    if (this.blnabroad === true) {
      this.studentdetail.abroad = "Y";
    } else {
      this.studentdetail.abroad = "N";
    }

    if (this.blntravel === true) {
      this.studentdetail.travel = "Y";
    } else {
      this.studentdetail.travel = "N";
    }
  }

  mobilenovalidation() {
    if (
      this.studentdetail.mobno !== undefined &&
      this.studentdetail.mobno !== null
    ) {
      if (this.studentdetail.mobno.toString().length !== 10) {
        document.getElementById("txtstudmobno").focus();
        this.snackBar.open(
          "" + this.studentdetail.mobno,
          "Enter valid Mobileno",
          {
            duration: 2000,
          }
        );
      }
    }
    if (
      this.studentdetail.fathersmobno !== undefined &&
      this.studentdetail.fathersmobno !== null
    ) {
      if (this.studentdetail.fathersmobno.toString().length !== 10) {
        document.getElementById("txtfathermobno").focus();
        this.snackBar.open(
          "" + this.studentdetail.fathersmobno,
          "Enter valid Mobileno",
          {
            duration: 2000,
          }
        );
      }
    }

    this.chkMobileno();
  }

  chkRollno() {
    if (
      this.blnedit === false &&
      this.studentdetail.clgrollno !== undefined &&
      this.studentdetail.clgrollno !== null &&
      this.studentdetail.clgrollno !== ""
    ) {
      this.commonRollnoCheck();
    } else {
      this.blnchkrollno = false;
    }
    if (
      this.blnedit === true &&
      this.studentdetail.clgrollno !== undefined &&
      this.studentdetail.clgrollno !== null &&
      this.studentdetail.clgrollno !== "" &&
      this.studentdetail.clgrollno === this.oldrollno
    ) {
      this.blnchkrollno = true;
    } else {
      // this.commonRollnoCheck();
      if (
        this.studentdetail.clgrollno !== undefined &&
        this.studentdetail.clgrollno !== null &&
        this.studentdetail.clgrollno !== ""
      ) {
        this.commonRollnoCheck();
      } else {
        this.blnchkrollno = false;
      }
    }
  }

  chkyearofpas() {
    if (
      this.studentdetail.yearofpas !== "" &&
      this.studentdetail.yearofpas >
        new Date().getFullYear() + (new Date().getMonth() <= 3 ? -1 : 0) + "-03"
    ) {
      alert("Please Choose The Valid Year Of Pass");
      document.getElementById('cmbyop').focus;
      return;
    } else if (this.studentdetail.yearofpas == "") {
      alert("Please Choose The Valid Year Of Pass");
      document.getElementById('cmbyop').focus;
      return;
    }
  }

  commonRollnoCheck() {
    this.chkrollnodata.rollno = JilabaAesED.Encrypt(
      this.studentdetail.clgrollno,
      JilabaKeyEnum.CommonKey
    );
    this.chkrollnodata.clgcode = JilabaAesED.Encrypt(
      this.studentdetail.clgcode,
      JilabaKeyEnum.CommonKey
    );
    this.chkrollnodata.hashData =
      JilabaAesED.Encrypt(
        this.studentdetail.clgrollno,
        JilabaKeyEnum.CommonKey
      ) +
      JilabaAesED.Encrypt(this.studentdetail.clgcode, JilabaKeyEnum.CommonKey);
    this.studentevaluation.chkrollno(this.chkrollnodata).subscribe((data) => {
      try {
        this.returnstatus = data;
        if (
          this.returnstatus.status === true &&
          this.returnstatus.description !== ""
        ) {
          document.getElementById("txtrollno").focus();
          this.snackBar.open(
            "" + this.studentdetail.clgrollno,
            this.returnstatus.description,
            {
              duration: 2000,
            }
          );
          this.blnchkrollno = false;
        } else {
          this.blnchkrollno = true;
        }
      } catch (error) {
        console.log(this.returnstatus.description);
      }
    });
  }

  chkMobileno() {
    if (
      this.blnedit === false &&
      this.studentdetail.mobno !== undefined &&
      this.studentdetail.mobno !== null &&
      this.studentdetail.mobno !== ""
    ) {
      this.commonMobilenoCheck();
    }
    if (
      this.blnedit === true &&
      this.studentdetail.mobno !== undefined &&
      this.studentdetail.mobno !== null &&
      this.studentdetail.mobno !== "" &&
      this.studentdetail.mobno === this.oldmobileno
    ) {
      this.blnchkmobno = true;
    } else {
      this.commonMobilenoCheck();
    }
  }

  commonMobilenoCheck() {
    try {
      let map: any = {
        mobileno: this.studentdetail.mobno,
        tocken: JilabaAesED.Encrypt(
          this.studentdetail.mobno,
          JilabaKeyEnum.CommonKey
        ),
      };
      this.studentevaluation.chkmobileno(map).subscribe((data) => {
        try {
          this.returnstatus = data;
          if (
            this.returnstatus.status === true &&
            this.returnstatus.description !== ""
          ) {
            document.getElementById("txtstudmobno").focus();
            this.snackBar.open(
              "" + this.studentdetail.mobno,
              this.returnstatus.description,
              {
                duration: 2000,
              }
            );
            this.blnchkmobno = false;
          } else {
            this.blnchkmobno = true;
          }
        } catch (error) {
          console.log(error.message);
        }
      });
    } catch (error) {
      console.log(error.message);
    }
  }

  confirmvalidation(): boolean {
    try {
      if (this.studentdetail.mobno !== this.studentdetail.cnfrmmobno) {
        document.getElementById("txtstudmobno").focus();
        this.snackBar.open(
          "" + this.studentdetail.mobno,
          "Mobileno does not match",
          {
            duration: 2000,
          }
        );
        return false;
      }

      if (this.studentdetail.email !== this.studentdetail.cnfrmemail) {
        document.getElementById("txtemail").focus();
        this.snackBar.open(
          "" + this.studentdetail.email,
          "Email does not match",
          {
            duration: 2000,
          }
        );
        return false;
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  markvalidation(): boolean {
    if (this.studentdetail.tnthmark > 100 || this.studentdetail.tnthmark < 0) {
      document.getElementById("txttenmark").focus();
      this.snackBar.open(
        "" + this.studentdetail.tnthmark,
        "Invalid 10th Mark",
        {
          duration: 2000,
        }
      );
      return false;
    } else if (
      this.studentdetail.tnthmaths > 100 ||
      this.studentdetail.tnthmaths < 0
    ) {
      document.getElementById("txttenmathsmark").focus();
      this.snackBar.open(
        "" + this.studentdetail.tnthmaths,
        "Invalid 10th Maths Mark",
        {
          duration: 2000,
        }
      );
      return false;
    } else if (
      this.studentdetail.twelthmark > 100 ||
      this.studentdetail.twelthmark < 0
    ) {
      document.getElementById("txttwelmark").focus();
      this.snackBar.open(
        "" + this.studentdetail.twelthmark,
        "Invalid 12th/Diploma Mark",
        {
          duration: 2000,
        }
      );
      return false;
    } else if (
      this.studentdetail.twelthmaths > 200 ||
      this.studentdetail.twelthmaths < 0
    ) {
      document.getElementById("txttwelmathsmark").focus();
      this.snackBar.open(
        "" + this.studentdetail.twelthmaths,
        "Invalid 12th/Diploma Maths Mark",
        {
          duration: 2000,
        }
      );
      return false;
    } else if (this.studentdetail.cgpa > 10 || this.studentdetail.cgpa < 0) {
      document.getElementById("txtcgpa").focus();
      this.snackBar.open("" + this.studentdetail.cgpa, "Invalid CGPA", {
        duration: 2000,
      });
      return false;
    } else {
      return true;
    }
  }

  validation(): boolean {
    if (this.clgName === false) {
      if (
        this.studentdetail.clgname === undefined ||
        this.studentdetail.clgname === null ||
        this.studentdetail.clgname === "" ||
        this.studentdetail.clgname.trim() === ""
      ) {
        document.getElementById("clgName").focus();
        alert("College Name is mandatory");
        return false;
      }
    }
    if (
      this.studentdetail.yearofpas === undefined ||
      this.studentdetail.yearofpas === null ||
      this.studentdetail.yearofpas === ""
    ) {
      document.getElementById("cmbyop").focus();
      alert("Select Year of Passing");
      return false;
    } else if (
      this.studentdetail.clgrollno === undefined ||
      this.studentdetail.clgrollno === null ||
      this.studentdetail.clgrollno === ""
    ) {
      if (this.blnchkrollno === false) {
        document.getElementById("txtrollno").focus();
        alert("College Rollno is mandatory");
        return false;
      } else {
        document.getElementById("txtrollno").focus();
        alert("Rollno is Already Exist");
        return false;
      }
    } else if (
      this.studentdetail.studname === undefined ||
      this.studentdetail.studname === null ||
      this.studentdetail.studname === ""
    ) {
      document.getElementById("txtstudname").focus();
      alert("Student name is mandatory");
      return false;
    } else if (
      this.studentdetail.age === undefined ||
      this.studentdetail.age === null
    ) {
      document.getElementById("dobpicker").focus();
      alert("Select Date of Birth");
      return false;
    } else if (
      this.studentdetail.fathersname === undefined ||
      this.studentdetail.fathersname === null ||
      this.studentdetail.fathersname === ""
    ) {
      document.getElementById("txtfathername").focus();
      alert("Father name is mandatory");
      return false;
    } else if (
      this.studentdetail.fathersocc === undefined ||
      this.studentdetail.fathersocc === null ||
      this.studentdetail.fathersocc === ""
    ) {
      document.getElementById("txtfatheroccu").focus();
      alert("Father occupation is mandatory");
      return false;
    } else if (
      this.studentdetail.mothersname === undefined ||
      this.studentdetail.mothersname === null ||
      this.studentdetail.mothersname === ""
    ) {
      document.getElementById("txtmothername").focus();
      alert("Mother name is mandatory");
      return false;
    } else if (
      this.studentdetail.mothersocc === undefined ||
      this.studentdetail.mothersocc === null ||
      this.studentdetail.mothersocc === ""
    ) {
      document.getElementById("txtmotheroccu").focus();
      alert("Mother occupation is mandatory");
      return false;
    } else if (
      this.studentdetail.mobno === undefined ||
      this.studentdetail.mobno === null ||
      this.studentdetail.mobno === ""
    ) {
      document.getElementById("txtstudmobno").focus();
      alert("Student mobileno is mandatory");
      return false;
    } else if (
      this.studentdetail.cnfrmmobno === undefined ||
      this.studentdetail.cnfrmmobno === null ||
      this.studentdetail.cnfrmmobno === ""
    ) {
      document.getElementById("txtcnfrmstudmobno").focus();
      alert("Confirm Student mobileno");
      return false;
    } else if (
      this.studentdetail.fathersmobno === undefined ||
      this.studentdetail.fathersmobno === null ||
      this.studentdetail.fathersmobno === ""
    ) {
      document.getElementById("txtfathermobno").focus();
      alert("Father mobileno is mandatory");
      return false;
    } else if (
      this.studentdetail.email === undefined ||
      this.studentdetail.email === null ||
      this.studentdetail.email === ""
    ) {
      document.getElementById("txtemail").focus();
      alert("Emailid is mandatory");
      return false;
    } else if (
      this.studentdetail.cnfrmemail === undefined ||
      this.studentdetail.cnfrmemail === null ||
      this.studentdetail.cnfrmemail === ""
    ) {
      document.getElementById("txtcnfrmemail").focus();
      alert("Confirm Student Email");
      return false;
    } else if (this.studentdetail.mobno !== this.studentdetail.cnfrmmobno) {
      document.getElementById("txtstudmobno").focus();
      alert("Mobile number does not match");
      return false;
    } else if (this.studentdetail.email !== this.studentdetail.cnfrmemail) {
      document.getElementById("txtemail").focus();
      alert("Email does not match");
      return false;
    } else if (
      this.studentdetail.gender === undefined ||
      this.studentdetail.gender === null ||
      this.studentdetail.gender === ""
    ) {
      document.getElementById("radgender").focus();
      alert("Gender is mandatory");
      return false;
    } else if (
      this.selectededucation.type === undefined ||
      this.selectededucation.type === null
    ) {
      document.getElementById("cmbedu").focus();
      alert("Fill Education Detail");
      return false;
    } else if (
      this.selecteddepartment.type === undefined ||
      this.selecteddepartment.type === null
    ) {
      document.getElementById("cmbdep").focus();
      alert("Fill Department Detail");
      return false;
    } else if (this.selectedtechnical.length === 0) {
      document.getElementById("cmbtech").focus();
      alert("Fill Technical Detail");
      return false;
    } else if (this.selecteddatabase.length === 0) {
      document.getElementById("cmbdb").focus();
      alert("Fill Database Detail");
      return false;
    } else if (this.selectedlanguage.length === 0) {
      document.getElementById("cmblang").focus();
      alert("Fill Language Detail");
      return false;
    } else if (
      this.studentdetail.tnthmark === undefined ||
      this.studentdetail.tnthmark === null
    ) {
      document.getElementById("txttenmark").focus();
      alert("10th mark is mandatory");
      return false;
    } else if (
      this.studentdetail.tnthmaths === undefined ||
      this.studentdetail.tnthmaths === null
    ) {
      document.getElementById("txttenmathsmark").focus();
      alert("10th maths mark is mandatory");
      return false;
    } else if (
      this.studentdetail.twelthmark === undefined ||
      this.studentdetail.twelthmark === null
    ) {
      document.getElementById("txttwelmark").focus();
      alert("12th/Diploma mark is mandatory");
      return false;
    } else if (
      this.studentdetail.twelthmaths === undefined ||
      this.studentdetail.twelthmaths === null
    ) {
      document.getElementById("txttwelmathsmark").focus();
      alert("12th/Diploma maths mark is mandatory");
      return false;
    } else if (
      this.studentdetail.cgpa === undefined ||
      this.studentdetail.cgpa === null
    ) {
      document.getElementById("txtcgpa").focus();
      alert("CGPA is mandatory");
      return false;
    }
    // else if (this.studentdetail.image === '' || this.studentdetail.image === 'assets/img/user.png') {
    //   alert('Upload Student Image');
    // return false;
    // }
    else {
      return true;
    }
  }

  async save() {
    try {
      console.log(this.studentdetail);

      this.chkMobileno();
      this.chkRollno();
      this.chkyearofpas();
      if (
        this.validation() === true &&
        this.markvalidation() === true &&
        this.blnchkmobno === true &&
        this.blnchkrollno === true
      ) {
        this.blnsave = false;
        this.spinner.show();
        this.selecteddetails = new Array<TypeListitem>();
        this.selecteddetails.push(this.selectededucation);
        this.selecteddetails.push(this.selecteddepartment);
        this.selectedtechnical.forEach((technical) => {
          this.selecteddetails.push(technical);
        });
        this.selecteddatabase.forEach((database) => {
          this.selecteddetails.push(database);
        });
        if (this.selectedpackage.length > 0) {
          this.selectedpackage.forEach((adpackage) => {
            this.selecteddetails.push(adpackage);
          });
        }
        this.selectedlanguage.forEach((language) => {
          this.selecteddetails.push(language);
        });
        if (AppconfigService.otpstatus === true) {
          this.returnstatus = await this.studentsave.stuupdate(
            this.studentdetail,
            this.selecteddetails
          );

          if (this.returnstatus.status === true) {
            this.studentno = this.returnstatus.description;
            let studentNo = JilabaAesED.Decrypt(
              this.studentno,
              JilabaKeyEnum.CommonKey
            );
            await this.saveImage(studentNo);
            await this.releaseLock(event);
            await this.loadPDF(studentNo);
            this.spinner.hide();
            this.openUpdateDialog();
          } else {
            console.log(this.returnstatus.description);
            this.spinner.hide();
            this.loading = false;
            alert("Failed To Update Your Registration Details!!!");
            this.router.navigate(["/main"]);
          }
        } else {
          this.studentdetail.type = sessionStorage.getItem("clgtype");
          this.returnstatus = await this.studentsave.stusave(
            this.studentdetail,
            this.selecteddetails
          );
          if (this.returnstatus.status === true) {
            this.studentno = this.returnstatus.description;
            let studentNo = JilabaAesED.Decrypt(
              this.studentno,
              JilabaKeyEnum.CommonKey
            );
            await this.saveImage(studentNo);
            await this.loadPDF(studentNo);

            this.openSaveDialog();
            this.spinner.hide();
          } else {
            console.log(this.returnstatus.description);

            this.loading = false;
            this.router.navigate(["/main"]);
            alert("Failed To Save Your Registration Details!!!");
            this.spinner.hide();
            this.blnsave = true;
          }
        }
      }
    } catch (error) {
      this.spinner.hide();
      console.log(error.message);
    }
  }

  validate() {
    if (
      this.studentdetail.clgrollno == undefined ||
      this.studentdetail.clgrollno !== null ||
      this.studentdetail.clgrollno == ""
    ) {
      this.snackBar.open("College Rollno should not be empty...!", "close", {
        duration: 2000,
      });
      document.getElementById("txtrollno").focus();
      return false;
    }

    if (
      this.studentdetail.studname == undefined ||
      this.studentdetail.studname !== null ||
      this.studentdetail.studname == ""
    ) {
      this.snackBar.open("Student Name should not be empty...!", "close", {
        duration: 2000,
      });
      document.getElementById("txtstudname").focus();
      return false;
    }

    return true;
  }

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      this.selecetdFile = event.target.files[0];

      if (this.selecetdFile.size > 500 * 1024) {
        alert("Image size must in below 500kb");

        let image: any = <HTMLInputElement>document.getElementById("stuimg");
        image.value = null;
        this.studentdetail.image = null;
        event = null;
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        this.show = true;
        this.studentdetail.image = reader.result;
      };
      reader.readAsDataURL(this.selecetdFile);
    }
  }

  async saveImage(studno: string) {
    if (this.selecetdFile !== undefined) {
      await this.studentevaluation.pushFileToStorage(this.selecetdFile, studno);
    } else {
      await this.studentevaluation.pushWithoutImage(studno).then((data) => {
        if (data.status == false) {
          alert(
            "Failed To Save Image !!! Update Your Details Using Existing User Login Option"
          );
        }
      });
    }
  }

  async loadPDF(studno: string) {
    let map: any = {
      studno: studno,
      tocken: JilabaAesED.Encrypt(studno, JilabaKeyEnum.CommonKey),
    };
    await this.studentevaluation.loadpdf(map).then((data) => {
      this.returnstatus = data;
      if (this.returnstatus.status === true) {
        const map: any = this.returnstatus.returnObject;
        alert(
          "Kindly fill and carry both the documents with you when attending the examination. They are required to be filled and kept ready"
        );
        Common.loadPdf(map["byteData"], studno);
        // Common.createPDF(studno, this.studentdetail.clgname ? this.studentdetail.clgname : this.collegename, this.studentdetail.studname);
        return;
      }
      console.log(this.returnstatus.description);
      this.loading = false;
      alert(
        "Failed  To Generate PDF, Please Download PDF From Existing User (or) Edit Your Details From Existing User Login!!!"
      );
      this.spinner.hide();
      this.router.navigate(["/main"]);
    });
  }

  openSaveDialog(): void {
    this.loading = false;
    const dialogRef = this.dialog.open(SavedialogComponent, {
      disableClose: true,
      // width: '460px',
      // height: '220px',
      data: {
        dialogstudentno: JilabaAesED.Decrypt(
          this.studentno,
          JilabaKeyEnum.CommonKey
        ),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.studentno = "";
      this.afterSave();
    });
  }

  openUpdateDialog(): void {
    this.loading = false;
    this.spinner.hide();
    const dialogRef = this.dialog.open(UpdatedialogComponent, {
      disableClose: true,
      // width: '460px',
      // height: '220px',JilabaAesED.Decrypt(this.studentno,JilabaKeyEnum.CommonKey)
      data: {
        dialogstudentno: JilabaAesED.Decrypt(
          this.studentno,
          JilabaKeyEnum.CommonKey
        ),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.studentno = "";
      this.afterSave();
    });
  }

  afterSave() {
    this.studentdetail = new StudentDetail();
    this.selecteddetails = new Array<TypeListitem>();
    this.blnabroad = false;
    this.blnindia = false;
    this.blntravel = false;
    this.show = false;
    this.studentdetail.image = "";
    this.loadDetailPojo = new LoadDetailPojo();
    this.lstcollege = new Array<Listitem>();
    this.lstdepartment = new Array<TypeListitem>();
    this.lsteducation = new Array<TypeListitem>();
    this.lsttechnical = new Array<TypeListitem>();
    this.lstdatabase = new Array<TypeListitem>();
    this.lstpackage = new Array<TypeListitem>();
    this.lstlanguage = new Array<TypeListitem>();
    this.selecteddepartment = new TypeListitem();
    this.selectededucation = new TypeListitem();
    this.selectedtechnical = new Array<TypeListitem>();
    this.selecteddatabase = new Array<TypeListitem>();
    this.selectedpackage = new Array<TypeListitem>();
    this.selectedlanguage = new Array<TypeListitem>();
    this.selecteddetails = new Array<TypeListitem>();
    this.blnchkmobno = false;
    this.blnchkrollno = false;
    window.location.reload();
  }
}
